module.exports = __webpack_public_path__ + "media/images/covid/banner/sidebar/th-8c83804f6d7b781731f30121da1e1650.jpg";